import { css } from "@emotion/css";
import { ExternalLink, Text } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { useMemo } from "react";
import { SourceCardList } from "~/areas/infrastructure/components/ArgoCDInstances/components/GenerateArgoCDAnnotationsDrawer/components/SourceCardList";
import type { ConfiguredSource, ConfiguredSources } from "../ConfiguredSource";
import { sharedStyles } from "../sharedStyles";
import { AnnotationHelpNote } from "./AnnotationHelpNote";
const styles = {
    annotationHelp: css({
        marginBottom: space[16],
    }),
    helmAnnotationContainer: css({
        display: "flex",
        flexDirection: "row",
        gap: space[8],
    }),
};
type HelmExpressionConfigurationViewProps = {
    index: number;
    configuredSources: ConfiguredSources;
    setConfiguredSources: (configuredSources: ConfiguredSources) => void;
    isMultiSourceApplication: boolean;
};
export const HelmExpressionConfigurationView = (props: HelmExpressionConfigurationViewProps) => {
    const { index, configuredSources, setConfiguredSources, isMultiSourceApplication } = props;
    const updateConfiguredSource = (key: string, updated: Partial<ConfiguredSource>) => {
        const updatedSources = { ...configuredSources };
        updatedSources[key] = {
            ...configuredSources[key],
            ...updated,
        };
        setConfiguredSources(updatedSources);
    };
    const helmConfiguredSources = useMemo(() => {
        const helmEntries = Object.entries(configuredSources).filter(([, configuredSource]) => configuredSource.isHelmSource);
        return Object.fromEntries(helmEntries);
    }, [configuredSources]);
    const hideAnnotationHelp = Object.keys(helmConfiguredSources).length === 1;
    return (<div>
            <h2 className={sharedStyles.header}>{index}. Configure Helm annotations</h2>
            <div className={styles.annotationHelp}>
                <p>
                    Helm requires additional annotations if you want to use the <strong>Update Argo CD Application Image Tags</strong> step.
                </p>
                {!hideAnnotationHelp && <AnnotationHelpNote />}
            </div>
            <SourceCardList configuredSources={helmConfiguredSources} isMultiSourceApplication={isMultiSourceApplication} showMissingNameWarning hideSourceHeader={!isMultiSourceApplication} cardContentRenderer={(key, configuredSource) => (<div>
                        <Text label={"Image template expression"} value={configuredSource.helmExpression} onChange={(val) => updateConfiguredSource(key, { helmExpression: val })} helperText={<div>
                                    Provide the expression that defines the container image in your Helm chart, e.g.
                                    <br />
                                    <div className={styles.helmAnnotationContainer}>
                                        {"e.g. \"{{ .Values.image.repository }}:{{ .Values.image.tag }}\""}
                                        <ExternalLink href={"argo-cd-helm-image-annotations"} size={"small"}>
                                            Read The Docs
                                        </ExternalLink>
                                    </div>
                                </div>} margin={"none"} customMargins={"0"}/>
                    </div>)}/>
        </div>);
};
